import {Outlet} from "react-router-dom";
import {OrdersPageContainer} from "./styled";
import {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "../../redux/store";
import {getMyRecipients} from "../../redux/slices/recipients.slice";
import {
    getOrderTypes,
    getPaymentStatuses,
    getPaymentTypes,
    getProductCategories,
    getProductStores,
    getProductTypes,
    getRecipientDocumentTypes,
    getShippingMethods
} from "../../redux/slices/static-data.slice";
import {changeSidebarInOrders, changeSidebarWithNavigate} from "../../redux/slices/sidebar.slice";
import {OutletContext} from "../../router/router";

const OrdersPage = ({context}: {context: OutletContext }) => {
    const {matchesPhone} = useAppSelector(state => state.deviceReducer);
    const [isReady, setIsReady] = useState<boolean>(false);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!isReady) {
            dispatch(changeSidebarInOrders(true));
            dispatch(changeSidebarWithNavigate(false));

            Promise.allSettled([
                dispatch(getShippingMethods()),
                dispatch(getPaymentStatuses()),
                dispatch(getPaymentTypes()),
                dispatch(getMyRecipients({forceLoad: false})),
                dispatch(getOrderTypes()),
                dispatch(getProductTypes()),
                dispatch(getRecipientDocumentTypes()),
                dispatch(getProductCategories()),
                dispatch(getProductStores({}))
            ])
                .then(() => {
                    setIsReady(true);
                });
        }
    }, [isReady]);

    return (
        <OrdersPageContainer style={{padding: matchesPhone ? 0 : '0 2.5rem'}}>
            {isReady ? <Outlet context={context}/> : <></>}
        </OrdersPageContainer>
    );
};

export default OrdersPage;



